<a class="link" routerLink="veicolo-usato/{{veicolo.vclPratica}}">
	<img class="img-fluid card-img link" [src]="veicolo.imageToShow">
</a>
<div>

	<a class="link" routerLink="veicolo-usato/{{veicolo.vclPratica}}"> 
		<b>({{veicolo.vclPratica}}) <span
			*ngIf="veicolo.vclTipologia != '' || veicolo.vclcntVclTipo != ''">{{veicolo.vclTipologia}} {{veicolo.vclcntVclTipo}}
			-</span> Anno: {{veicolo.vclDataImmatr | date:'yyyy'}}</b>
		<br>                
		<br>
		{{veicolo.vclMarca}} {{veicolo.vclMod}} {{veicolo.vclAliment}}
		<br>
		Data immatr.
		{{veicolo.vclDataImmatr | date:'dd/MM/yyyy'}}
		<br>
		Km {{veicolo.vclKmPercorsi}}
		<br>
		<span style="font-weight: bold; color: red;" *ngIf="loggato">
			{{veicolo.vclUsatoValoreVendita | currency:'EUR':'symbol'}}
		</span>
	</a>